import { ConstantsCodesObjectType, ConstantsCodeType } from 'src/types/constantsCodes';
import { checkPermission } from 'src/utils/checkPermission';
import { ClaimStatusesTo } from 'skladon-types';
import { ClaimType } from 'src/types/claim';
import { FormErrorsType } from '../../types/global';
import { CLAIM_ERROR_LOG_FIELD_KEYS } from './constants';
import { sortByClaimStatusOrder } from 'src/resources/constantsCodes/functions';

export const getAllowedStatuses = (
    claimStatusCodes: ConstantsCodeType[],
    claimStatusCodesObject: ConstantsCodesObjectType,
    claimData?: { STATUS?: string } | null
): ConstantsCodeType[] => {
    if (checkPermission('CLAIM.EDITALL')) {
        return sortByClaimStatusOrder(claimStatusCodes);
    }

    if (!claimData || !claimData.STATUS) {
        return [];
    }

    return sortByClaimStatusOrder([
        claimStatusCodesObject[claimData.STATUS],
        ...(ClaimStatusesTo[claimData.STATUS] || [])
            .filter((statusKey) => {
                return checkPermission(`CLAIM.STATUS.LIST.${statusKey.toUpperCase()}`);
            })
            .map((statusKey) => {
                return claimStatusCodesObject[statusKey];
            }),
    ]);
};

export const validateErrorLogFields = (editData: ClaimType): FormErrorsType => {
    const errors: FormErrorsType = {};
    const requiredFields: Array<keyof ClaimType> = [
        'ERROR_DEPARTMENT',
        'ERROR_CATEGORY',
        'ERROR_DESCRIPTION',
        'ERROR_SEVERITY',
        'VIDEO_LINK'
    ];

    for (const field of requiredFields) {
        const value = editData[field];
        if (value === null || value === undefined || value === '') {
            errors[field] = true;
        }
    }

    return errors;
};

export const hasClaimInvoiceFile = (editData: ClaimType): boolean => {
    return Boolean(editData.FILES?.some((file) => file.type === 'invoice'));
};

export const validateClaimInvoiceFile = (editData: ClaimType): FormErrorsType => {
    if (hasClaimInvoiceFile(editData)) {
        return {};
    }
    return { invoice: true };
};

export const stripErrorLogFields = (data: ClaimType): ClaimType => {
    const result: Record<string, unknown> = { ...data };
    for (const key of CLAIM_ERROR_LOG_FIELD_KEYS) {
        delete result[key];
    }
    return result as ClaimType;
};
